import mutations from './mutations'
import actions from './actions'

const state = {
  calendar_inventory: [],
  calendar_camping: [],
  calendar_accomodation: [],
  calendar_external_accomodation: [],
  conservation_fees_calendar: [],
  vehicle_fees_calendar: [],
  vehicle_bookings: [],
  conservation_bookings: []
}

export default {
  state, mutations, actions
}
